import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { BaseService } from "../shared/services/base.service";
import { ExcelDownloadService } from "../shared/services/excel-download.service";


@Injectable({
  providedIn: 'root'
})
export class StsAdminService {
  public tierManageData = new BehaviorSubject<any>(null);
  tierManageData$ = this.tierManageData.asObservable();

  public deleteTierItem = new BehaviorSubject<any>(null);
  deleteTierItem$ = this.deleteTierItem.asObservable();

  public customerDetails = new BehaviorSubject<any>(null);
  customerDetails$ = this.customerDetails.asObservable();

  public shipWeekDetails = new BehaviorSubject<any>(null);
  shipWeekDetails$ = this.shipWeekDetails.asObservable();

  public shippingCommitData = new BehaviorSubject<any>(null);
  shippingCommitData$ = this.shippingCommitData.asObservable();

  public deleteShippingCommit = new BehaviorSubject<any>(null);
  deleteShippingCommit$ = this.deleteShippingCommit.asObservable();

  public dropdownOptions = new BehaviorSubject<any>(null);
  dropdownOptions$ = this.dropdownOptions.asObservable();

  public saveSTSMarketingDetails = new BehaviorSubject<any>(null);
  saveSTSMarketingDetails$ = this.saveSTSMarketingDetails.asObservable();

  constructor(public baseService: BaseService, public excelService: ExcelDownloadService) { }

  public getTierManagement() {
    this.baseService
      .get(`/sts-flu/tier-manage`)
      .subscribe((res) => {
        this.tierManageData.next(res);
      });
  }

  public updateTier(params) {
    return this.baseService.post('/sts-flu/tier-manage', params);
  }

  public deleteTier(params) {
    this.deleteTierItem.next(false);
    this.baseService.post('/sts-flu/remove-tier', params).subscribe((res) => {
      this.deleteTierItem.next(true);
    });
  }

  public viewCustomerDetails() {
    this.baseService.get(`sts-customer-upload/getStsCustomerDetails`).subscribe((res) => {
      this.customerDetails.next(res);
    });
  }

  public downloadXls(data, name) {
    this.excelService.exportHtmlTableAsExcelFile(data, name, true);
  }

  public downloadCustomerData(): Observable<any> {
    return this.baseService.get(`sts-customer-upload/excel-download`)
  }

  public getUploadFileData(file) {
    return this.baseService.postfile('sts-customer-upload/import-excel', file)
  }

  public getShippingWeekDetails() {
    this.baseService.get(`sts-shipping-week/getStsShipWeeks`).subscribe((res) => {
      this.shipWeekDetails.next(res);
    });
  }
  public getShippingCommitment(filters) {
    this.baseService
      .get(`/sts-shipping-commitment/getStsShippingCommitment`, filters)
      .subscribe((res) => {
        this.shippingCommitData.next(res);
      });
  }

  public postShippingWeekData(params) {
    return this.baseService.post('sts-shipping-week/update-for-all', params);
  }

  public getDropdownList(params) {
    this.baseService.post('sts-marketing-tool/stsorders', params).subscribe((res) => {
      this.dropdownOptions.next(res);
    });;
  }

  public downloadExcelShipCommit(): Observable<any> {
    return this.baseService.get(`/sts-shipping-commitment/excel-download`)
  }
  public deleteShipCommit(params) {
    this.deleteShippingCommit.next(false);
    this.baseService.post('/sts-shipping-commitment/remove-record', params).subscribe((res) => {
      this.deleteShippingCommit.next(true);
    });
  }
  shippingCommitUploadFile(file) {
    return this.baseService.postfile('/sts-shipping-commitment/import-excel', file)
  }
  updateShipCommit(params) {
    return this.baseService.post('/sts-shipping-commitment/update-record', params);
  }
  public getSeasonalList(): Observable<any> {
    return this.baseService.get(`/stsOrderExport`);
  }
  public orderExportExcel(params): Observable<any> {
    return this.baseService.post(`/export-excel`, params);
  }
  public updateSTSMarketingDetails(params) {
    this.baseService.post('/sts-marketing-tool/update-adjusted-qty', params).subscribe((res) => {
      this.saveSTSMarketingDetails.next(res);
    });
  }

}
